export default __webpack_public_path__ + "static/media/logo.202d9a03.png";